import type { StudentCatalogRoutes } from 'ulanano-cms-api/routes/student-catalog'
import { createGranularTreaty } from '../api-factory'

export const studentCatalogApi = createGranularTreaty<StudentCatalogRoutes>({ withCookies: true })
